import { FC } from 'react';

import { Range } from 'types';

import { formatNumber } from 'utils/formats';
import { useAvailableRangesView } from '../context/AvailableRangesViewContext';

type AvailableRangesTableRowProps = {
  range: Range;
};

const AvailableRangesViewExpandedTableRow: FC<AvailableRangesTableRowProps> = ({
  range,
}) => {
  const { actions } = useAvailableRangesView();
  const from = range?.from || 0;
  const to = range?.to || 0;

  const handleClickRange = () => {
    actions.handleClickRange(range);
  };

  return (
    <td
      className="badge btn-primary ml-1 cursor-pointer align-items-center h-20px"
      onClick={handleClickRange}
    >
      {formatNumber(from)}
      &nbsp;-&nbsp;
      {formatNumber(to)}
      &nbsp;
    </td>
  );
};

export default AvailableRangesViewExpandedTableRow;
